import moment from 'moment';

export default (date) => moment(date).format('YYYY-MM-DD');
